module.exports = __webpack_public_path__ + "static/media/defaultAvatar16.6ba4cd33.svg";